module.exports = __webpack_public_path__ + "static/media/notification_logo.cce921d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/notification_logo.png
// module id = 1458
// module chunks = 33